export default __webpack_public_path__ + "images/a555d7a184a5e52db08020456af3beb5-hockey.png";